<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import ModalHasilApproveAll from "./components/modal-hasil-approve-all.vue";
import axios from "axios";
import Swal from "sweetalert2";
import _ from "lodash";

export default {
  components: {
    Layout,
    PageHeader,
    Datatable,
    Pagination,
    ModalHasilApproveAll,
  },

  data() {
    let sortOrders = []; // select sortOrder
    // definisi kolom yang dipakai
    let columns = [
      { width: "50px", label: "No", name: "-" },
      { width: "150px", label: "NIP", name: "u_nip" },
      { width: "220px", label: "Nama Peserta", name: "nama" },
      { width: "200px", label: "Unit", name: "-" },
      { width: "220px", label: "Nama Profesi", name: "nama_profesi" },
      { width: "200px", label: "Jenjang Jabatan", name: "nama_jenjang" },
      { width: "150px", label: "Target Peg", name: "target_peg" },
      { width: "200px", label: "Target Kompetensi", name: "target_kompetensi" },
      { width: "200px", label: "Level Kompetensi", name: "level_kompetensi" },
      { width: "180px", label: "Status", name: "status" },
      { width: "140px", label: "Aksi", name: "-" },
    ];
    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      title: "Approver HCBP",
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,

      selectedPeserta: null,
      selectedProfesi: null,
      selectedJenjangJabatan: null,
      selectedTargetKompetensi: null,
      selectedLevelKompetensi: null,
      selectedStatus: null,
      optionPeserta: [],
      optionProfesi: [],
      optionJenjangJabatan: [],
      optionTargetKompetensi: [],
      optionLevelKompetensi: [],
      // status di halaman ini merujuk langsung ke WorkOrderAtasan.status: 1 -> atasan
      // belum melakukan approval kompetensi bawahannya (PENDING), 2 -> atasan sudah
      // approve, menunggu proses persetujuan HCBP (PROSES), 3 -> sudah disetujui HCBP
      // (DISETUJUI)
      optionStatus: [
        { value: 1, text: "PENDING" },
        { value: 2, text: "PROSES" },
        { value: 3, text: "DISETUJUI" },
      ],

      isApprovingAll: false,
      modalHasilApproveAll: false,
      hasilApproveAll: {
        total_diproses: 0,
        jumlah_berhasil: 0,
        jumlah_gagal: 0,
        gagal: [],
      },

      tableData: {
        columns: columns,
        sortKey: "u_nip",
        sortOrders: sortOrders,
        loading: true,
        data: [],
        filter: {
          page: 1,
          per_page: 10,
          idpegawai_internal: "",
          id_profesi: "",
          id_jenjang_jabatan: "",
          id_target_kompetensi: "",
          idlevel_kompetensi: "",
          status: "",
        },
        pagination: {
          lastPage: "",
          currentPage: "",
          total: "",
          lastPageUrl: "",
          nextPageUrl: "",
          prevPageUrl: "",
          from: "",
          to: "",
          links: "",
        },
      },
    };
  },

  watch: {
    selectedPeserta(val) {
      this.tableData.filter.idpegawai_internal = val?.idpegawai_internal ?? "";
      this.getDataTable();
    },
    selectedProfesi(val) {
      this.tableData.filter.id_profesi = val?.id_mprofesi ?? "";
      this.getDataTable();
    },
    selectedJenjangJabatan(val) {
      this.tableData.filter.id_jenjang_jabatan = val?.id_jenjang_jabatan ?? "";
      this.getDataTable();
    },
    selectedTargetKompetensi(val) {
      this.tableData.filter.id_target_kompetensi =
        val?.id_target_kompetensi ?? "";
      this.getDataTable();
    },
    selectedLevelKompetensi(val) {
      this.tableData.filter.idlevel_kompetensi = val?.idlevel_kompetensi ?? "";
      this.getDataTable();
    },
    selectedStatus(val) {
      this.tableData.filter.status = val?.value ?? "";
      this.getDataTable();
    },
  },

  created() {
    // debounce supaya request pencarian tidak dikirim setiap ketikan
    this.searchPeserta = _.debounce(this.onSearchPeserta, 400);
  },

  mounted() {
    this.getPeserta();
    this.getProfesi();
    this.getJenjangJabatan();
    this.getTargetKompetensi();
    this.getLevelKompetensi();
    this.getDataTable();
  },

  methods: {
    onSearchPeserta(search, loading) {
      loading(true);
      this.getPeserta(search, loading);
    },
    getPeserta(search = "", loading = () => {}) {
      axios({
        method: "get",
        url: this.BACKEND_URL_VERSION + "master/pegawai-internal/search",
        params: { search: search, is_get_all: false, limit: 50 },
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          this.optionPeserta = res.data?.data ?? [];
          loading(false);
        })
        .catch((err) => {
          console.log(err);
          loading(false);
        });
    },
    getProfesi() {
      axios({
        method: "get",
        url: this.BACKEND_URL_VERSION + "master/profesi",
        params: { per_page: 200, column: "nama_profesi", dir: "asc", filter_status: 'ENABLE' },
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          this.optionProfesi = res.data?.data?.data ?? [];
        })
        .catch((err) => console.log(err));
    },
    getJenjangJabatan() {
      axios({
        method: "get",
        url: this.BACKEND_URL_VERSION + "master-asesmen/jenjang-jabatan",
        params: { per_page: 200, column: "nama_jenjang", dir: "asc" },
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          this.optionJenjangJabatan = res.data?.data?.data ?? [];
        })
        .catch((err) => console.log(err));
    },
    getTargetKompetensi() {
      axios({
        method: "get",
        url: this.BACKEND_URL_VERSION + "master-asesmen/target-kompetensi",
        params: { per_page: 200, column: "target_kompetensi", dir: "asc" },
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          this.optionTargetKompetensi = res.data?.data?.data ?? [];
        })
        .catch((err) => console.log(err));
    },
    getLevelKompetensi() {
      axios({
        method: "get",
        url: this.BACKEND_URL_VERSION + "verifikasi/level-kompetensi",
        params: { per_page: 200, column: "nama_level", dir: "asc" },
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          this.optionLevelKompetensi = res.data?.data?.data ?? [];
        })
        .catch((err) => console.log(err));
    },
    getDataTable(resetPage = true) {
      let self = this;
      self.tableData.loading = true;
      if (resetPage) {
        self.tableData.filter.page = 1;
      }

      var config = {
        method: "get",
        url:
          self.BACKEND_URL_VERSION +
          "pegawai/pemilihan-kompetensi/approver-hcbp",
        params: {
          username: localStorage.getItem("session_username"),
          ...self.tableData.filter,
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          let response_data = response.data;
          if (response_data.meta.code == 200) {
            let response_data_fix = response_data.data;
            self.tableData.data = response_data_fix.data;
            self.configPagination(response_data_fix);
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data.meta.message,
            });
          }
          self.tableData.loading = false;
        })
        .catch((errors) => {
          console.log(errors);
          self.tableData.loading = false;
        });
    },
    configPagination(data) {
      this.tableData.pagination.lastPage = data.last_page;
      this.tableData.pagination.currentPage = data.current_page;
      this.tableData.pagination.total = data.total;
      this.tableData.pagination.lastPageUrl = data.last_page_url;
      this.tableData.pagination.nextPageUrl = data.next_page_url;
      this.tableData.pagination.prevPageUrl = data.prev_page_url;
      this.tableData.pagination.from = data.from;
      this.tableData.pagination.to = data.to;
      this.tableData.pagination.links = data.links;
    },
    toPage(url) {
      let link = new URLSearchParams(url.split("?")[1] || "");
      this.tableData.filter.page = link.get("page");
      this.getDataTable(false);
    },
    sortBy(key) {
      let self = this;
      self.tableData.sortKey = key;
      self.tableData.sortOrders[key] = self.tableData.sortOrders[key] * -1;
      self.getDataTable();
    },
    goToDetail(row_data) {
      console.log('detail', row_data);
      this.$router.push({
        name: "approver-hcbp-detail",
        params: { id: row_data.id_work_order_atasan },
        query: {
          idpegawai_internal: row_data.idpegawai_internal,
          id_work_order: row_data.id_work_order,
          id_work_order_detail: row_data.id_work_order_detail,
        },
      });
    },
    exportData() {
      // sengaja tidak mengoper filter status -> hasil export selalu berisi 2 sheet
      // (Sudah Disetujui & Belum Disetujui), tidak ikut status yang sedang difilter
      let filter = {
        username: localStorage.getItem("session_username"),
        idpegawai_internal: this.tableData.filter.idpegawai_internal,
        id_profesi: this.tableData.filter.id_profesi,
        id_jenjang_jabatan: this.tableData.filter.id_jenjang_jabatan,
        id_target_kompetensi: this.tableData.filter.id_target_kompetensi,
        idlevel_kompetensi: this.tableData.filter.idlevel_kompetensi,
      };
      let params = new URLSearchParams(filter).toString();
      window.open(
        this.BACKEND_URL_VERSION +
          "export-excel/approver-hcbp-bawahan?" +
          params
      );
    },
    approveAllBawahan() {
      if (this.isApprovingAll) return;
      let self = this;

      Swal.fire({
        icon: "warning",
        title: "Apakah anda yakin ingin menyetujui semua data ini?",
        text: "Seluruh bawahan Anda akan disetujui, terlepas dari filter yang sedang aktif di halaman ini.",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Ya, Setujui Semua",
        denyButtonText: "Batal",
      }).then((result) => {
        if (!result.isConfirmed) return;

        self.isApprovingAll = true;

        axios
          .post(
            self.BACKEND_URL_VERSION +
              "pegawai/pemilihan-kompetensi/approver-hcbp/approve-all",
            {
              username: localStorage.getItem("session_username"),
            },
            {
              headers: {
                Authorization: "Bearer " + localStorage.access_token,
              },
            }
          )
          .then((response) => {
            if (response.data.meta.code == 200) {
              let hasil = response.data.data;

              Swal.fire({
                icon: "success",
                title: "Berhasil",
                text:
                  hasil.total_diproses > 0
                    ? `${hasil.jumlah_berhasil} dari ${hasil.total_diproses} data berhasil disetujui.`
                    : "Tidak ada data yang perlu disetujui.",
                timer: 2000,
                timerProgressBar: true,
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                didClose: () => {
                  self.getDataTable(false);
                  if (hasil.jumlah_gagal > 0) {
                    self.hasilApproveAll = hasil;
                    self.modalHasilApproveAll = true;
                  }
                },
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: response.data.meta.message,
              });
            }
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Gagal",
              text:
                err.response?.data?.data ||
                err.response?.data?.meta?.message ||
                "Terjadi kesalahan saat approve semua data.",
            });
          })
          .finally(() => {
            self.isApprovingAll = false;
          });
      });
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card">
      <div class="card-body">
        <div class="mym-box">
          <div class="mym-box-left">
            <h4 class="fw-bold">List Data Peserta</h4>
          </div>
          <div class="mym-box-right">
            <b-button
              variant="warning"
              size="sm"
              class="fw-bold btn-block"
              :disabled="isApprovingAll"
              @click="approveAllBawahan"
            >
              <i class="fas fa-spinner fa-spin me-1" v-if="isApprovingAll"></i>
              <i class="fa fa-check-double me-1" v-else></i>
              Approve All
            </b-button>
            <b-button
              variant="success"
              size="sm"
              class="fw-bold btn-block ms-2"
              @click="exportData"
            >
              <i class="fa fa-file-excel me-1"></i>
              Export Excel
            </b-button>
          </div>
        </div>

        <hr />

        <div class="row mb-2">
          <div class="form-group col-md-4 mb-3">
            <label for="filterPeserta">Peserta</label>
            <v-select
              id="filterPeserta"
              :options="optionPeserta"
              label="nama"
              :get-option-key="(option) => option.idpegawai_internal"
              v-model="selectedPeserta"
              placeholder="Cari Peserta"
              :filterable="false"
              @search="searchPeserta"
            >
              <template #option="option">{{ option.nama }} - {{ option.u_nip }}</template>
              <template #selected-option="option">{{ option.nama }} - {{ option.u_nip }}</template>
              <template #no-options>Ketik untuk mencari peserta...</template>
            </v-select>
          </div>
          <div class="form-group col-md-4 mb-3">
            <label for="filterProfesi">Nama Profesi</label>
            <v-select
              id="filterProfesi"
              :options="optionProfesi"
              label="nama_profesi"
              :get-option-key="(option) => option.id_mprofesi"
              v-model="selectedProfesi"
              placeholder="Cari Profesi"
            >
              <template #option="option">{{ option.nama_profesi }}</template>
              <template #selected-option="option">{{ option.nama_profesi }}</template>
            </v-select>
          </div>
          <div class="form-group col-md-4 mb-3">
            <label for="filterJenjangJabatan">Jenjang Jabatan</label>
            <v-select
              id="filterJenjangJabatan"
              :options="optionJenjangJabatan"
              label="nama_jenjang"
              :get-option-key="(option) => option.id_jenjang_jabatan"
              v-model="selectedJenjangJabatan"
              placeholder="Semua"
            >
              <template #option="option">{{ option.nama_jenjang }}</template>
              <template #selected-option="option">{{ option.nama_jenjang }}</template>
            </v-select>
          </div>
          <div class="form-group col-md-4 mb-3">
            <label for="filterTargetKompetensi">Target Kompetensi</label>
            <v-select
              id="filterTargetKompetensi"
              :options="optionTargetKompetensi"
              label="target_kompetensi"
              :get-option-key="(option) => option.id_target_kompetensi"
              v-model="selectedTargetKompetensi"
              placeholder="Semua"
            >
              <template #option="option">{{ option.target_kompetensi }}</template>
              <template #selected-option="option">{{ option.target_kompetensi }}</template>
            </v-select>
          </div>
          <div class="form-group col-md-4 mb-3">
            <label for="filterLevelKompetensi">Level Kompetensi</label>
            <v-select
              id="filterLevelKompetensi"
              :options="optionLevelKompetensi"
              label="nama_level"
              :get-option-key="(option) => option.idlevel_kompetensi"
              v-model="selectedLevelKompetensi"
              placeholder="Semua"
            >
              <template #option="option">{{ option.nama_level }}</template>
              <template #selected-option="option">{{ option.nama_level }}</template>
            </v-select>
          </div>
          <div class="form-group col-md-4 mb-3">
            <label for="filterStatus">Status</label>
            <v-select
              id="filterStatus"
              :options="optionStatus"
              label="text"
              :get-option-key="(option) => option.value"
              v-model="selectedStatus"
              placeholder="Semua"
            >
              <template #option="option">{{ option.text }}</template>
              <template #selected-option="option">{{ option.text }}</template>
            </v-select>
          </div>
        </div>

        <div class="row">
          <datatable
            :columns="tableData.columns"
            :sortKey="tableData.sortKey"
            :sortOrders="tableData.sortOrders"
            @sort="sortBy"
          >
            <tbody>
              <tr v-if="tableData.loading">
                <td colspan="99" class="text-center">
                  <i class="fas fa-spinner fa-spin"></i> Loading...
                </td>
              </tr>
              <tr
                v-else-if="!tableData.data || tableData.data.length === 0"
                class="text-center"
              >
                <td class="text-center" colspan="99">Data Tidak Tersedia</td>
              </tr>
              <tr
                v-else
                v-for="(row_data, key_data) in tableData.data"
                :key="row_data.id_work_order_atasan"
              >
                <td class="text-center">
                  {{ (tableData.pagination.from || 1) + key_data }}
                </td>
                <td class="text-center">{{ row_data?.pegawai_internal?.u_nip || "-" }}</td>
                <td class="text-center">{{ row_data?.pegawai_internal?.nama || "-" }}</td>
                <td class="text-center">{{ row_data?.pegawai_internal?.unit_lev1?.nama_unitlev1 || "-" }}</td>
                <td class="text-center">{{ row_data?.profesi?.nama_profesi || "-" }}</td>
                <td class="text-center">{{ row_data?.work_order_detail?.jenjang_jabatan?.nama_jenjang || "-" }}</td>
                <td class="text-center">{{ row_data?.work_order_detail?.target_peg?.target_peg || "-" }}</td>
                <td class="text-center">{{ row_data?.work_order_detail?.target_kompetensi?.target_kompetensi || "-" }}</td>
                <td class="text-center">{{ row_data?.work_order_detail?.level_kompetensi?.nama_level || "-" }}</td>
                <td class="text-center">
                  <span v-if="row_data?.status == 1"
                    class="badge rounded-pill bg-gradient bg-warning py-2 px-4 fw-bold text-nowrap w-100"
                  >
                    <i class="far fa-hourglass me-1"></i>
                    PENDING
                  </span>
                  <span v-else-if="row_data?.status == 2"
                    class="badge rounded-pill bg-gradient bg-info py-2 px-4 fw-bold text-nowrap w-100"
                  >
                    <i class="fa fa-paper-plane me-1"></i>
                    PROSES
                  </span>
                  <span v-else-if="row_data?.status == 3"
                    class="badge rounded-pill bg-gradient bg-success py-2 px-4 fw-bold text-nowrap w-100"
                  >
                    <i class="fa fa-check me-1"></i>
                    DISETUJUI
                  </span>
                  <span v-else>-</span>
                </td>
                <td class="text-center">
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    @click="goToDetail(row_data)"
                  >
                    <i class="fa fa-eye me-1"></i> Detail
                  </button>
                </td>
              </tr>
            </tbody>
          </datatable>
        </div>
        <pagination :pagination="tableData.pagination" @to-page="toPage"></pagination>

        <hr class="five-dashes" />

        <div class="mt-2 d-flex flex-column align-items-end">
          <table class="table table-borderless mb-0 w-auto align-middle">
            <thead>
              <tr>
                <th colspan="3" class="text-end fw-bold p-2">Keterangan Status <i class="fas fa-info-circle text-primary ms-1"></i></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="px-2 text-muted text-end">Atasan belum melakukan approval kompetensi bawahannya</td>
                <td class="px-2">:</td>
                <td class="px-2 py-1">
                  <span class="badge rounded-pill bg-gradient bg-warning py-2 px-3 fw-bold text-nowrap">
                    <i class="far fa-hourglass me-1"></i> PENDING
                  </span>
                </td>
              </tr>
              <tr>
                <td class="px-2 text-muted text-end">Menunggu proses persetujuan dari HCBP</td>
                <td class="px-2">:</td>
                <td class="px-2 py-1">
                  <span class="badge rounded-pill bg-gradient bg-info py-2 px-3 fw-bold text-nowrap">
                    <i class="fa fa-paper-plane me-1"></i> PROSES
                  </span>
                </td>
              </tr>
              <tr>
                <td class="px-2 text-muted text-end">Sudah disetujui oleh HCBP</td>
                <td class="px-2">:</td>
                <td class="px-2 py-1">
                  <span class="badge rounded-pill bg-gradient bg-success py-2 px-3 fw-bold text-nowrap">
                    <i class="fa fa-check me-1"></i> DISETUJUI
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <ModalHasilApproveAll
          :show="modalHasilApproveAll"
          :result="hasilApproveAll"
          @close="modalHasilApproveAll = false"
        />
      </div>
    </div>
  </Layout>
</template>
